import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import FFEmptyData from '../../../../public/Images/FFEmptyData.png';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

type EmptyStateProps = {
  title: string;
  subtitle: string;
};

const useStyles = makeStyles()({
  emptyData: {
    padding: '0.5rem 2rem',
    display: 'flex',
    gap: '2rem',
    alignItems: 'center',
  },
});

export const EmptyState: React.FC<EmptyStateProps> = ({ title, subtitle }) => {
  const { classes } = useStyles();
  return (
    <Grid className={classes.emptyData}>
      <img src={FFEmptyData} />
      <Grid>
        <Typography
          fontSize="16px"
          fontType="semiBold"
          textColor={patientAccessTheme.palette.text.highemphasis}
          styleProps={{ marginBottom: '0.75rem' }}
        >
          {title}
        </Typography>
        <Typography
          fontSize="14px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
        >
          {subtitle}
        </Typography>
      </Grid>
    </Grid>
  );
};
